import React, { useState, useRef, useEffect } from 'react';
import { useForm } from 'react-final-form';
import PostcodeValidator from './postcodeValidator';
import { FFInputText } from '../text/text';
import { Button, Flex } from '@tpr/core';
import styles from './addressLookup.module.scss';
export var PostcodeLookup = function (_a) {
    var loading = _a.loading, testId = _a.testId, postcode = _a.postcode, onPostcodeChanged = _a.onPostcodeChanged, invalidPostcodeMessage = _a.invalidPostcodeMessage, postcodeLookupLabel = _a.postcodeLookupLabel, postcodeLookupButton = _a.postcodeLookupButton, findAddressCancelledButton = _a.findAddressCancelledButton, onFindAddressCancelled = _a.onFindAddressCancelled;
    var form = useForm();
    var validator = new PostcodeValidator(invalidPostcodeMessage);
    var searchFieldRef = useRef(null);
    var _b = useState(false), postcodeValid = _b[0], setPostcodeValid = _b[1];
    var clickFindAddress = function () {
        var myEvent = new Event('blur', { bubbles: true });
        searchFieldRef.current.dispatchEvent(myEvent);
        postcodeValid &&
            onPostcodeChanged(form.getFieldState('postcodeLookup').value);
    };
    useEffect(function () {
        searchFieldRef.current.value = null;
    });
    var validatePostcode = function (value) {
        var result = validator.validatePostcode(value);
        typeof result === 'undefined'
            ? setPostcodeValid(true)
            : setPostcodeValid(false);
        return result;
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(FFInputText, { ref: searchFieldRef, name: "postcodeLookup", value: postcode, label: postcodeLookupLabel, validate: function (value) { return validatePostcode(value); }, testId: (testId ? testId + '-' : '') + 'postcode-lookup-edit', inputClassName: styles.editPostcode, disabled: loading, defaultValue: '' }),
        React.createElement(Flex, { cfg: { flexDirection: 'row', mt: 2, alignItems: 'center' } },
            React.createElement(Button, { testId: (testId ? testId + '-' : '') + 'postcode-lookup-button', onClick: clickFindAddress, appearance: "secondary", disabled: loading || !postcodeValid }, postcodeLookupButton),
            onFindAddressCancelled && (React.createElement(Button, { cfg: { ml: 3 }, onClick: onFindAddressCancelled, testId: (testId ? testId + '-' : '') + 'find-address-cancel-button', appearance: "secondary" }, findAddressCancelledButton)))));
};
//# sourceMappingURL=postcodeLookup.js.map